module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 290
// module chunks = 40